export const baseURL = "https://api.alivedream.in/";
export const secretKey = "webintez_kklive_secret_key_2026";
export const projectName = "Alive Dream";
